import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('planejamento', 'orcamento/rateio');

const rateioActions = {
  ...genericActions(basePath),
  cabecalho: { method: 'GET', url: `${basePath}/{id}/cabecalho` },
  rateio: { method: 'GET', url: `${basePath}/{id}` },
  buscarFuncionarios: { method: 'GET', url: `${basePath}/{idOrcamento}/funcionarios` },
  buscarNovosVendedores: { method: 'GET', url: `${basePath}/{idOrcamento}/novos-vendedores` },
  adicionarNovosVendedores: { method: 'PUT', url: `${basePath}/{idOrcamento}/novos-vendedores` },
};

export default resource => resource(`${basePath}`, {}, rateioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/orcamento-rateio.js